var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "steps-outer" }, [
    _c("div", { staticStyle: { display: "flex", width: "100%" } }, [
      _c("div", { staticClass: "steps-container" }, [
        _c(
          "div",
          {
            staticClass: "steps-index",
            class: {
              "active-steps": _vm.activeSteps === 1,
              "completed-steps": _vm.activeSteps === 2 || _vm.activeSteps === 3,
            },
          },
          [_vm._v("1")]
        ),
        _c(
          "div",
          {
            staticStyle: { "margin-left": "5px" },
            style: { color: _vm.activeSteps === 1 ? "#0db35b" : "#333" },
          },
          [_vm._v(_vm._s(_vm.$t("basicData.UploadTheFile")))]
        ),
      ]),
      _vm._m(0),
      _c("div", { staticClass: "steps-container" }, [
        _c(
          "div",
          {
            staticClass: "steps-index",
            class: {
              "active-steps": _vm.activeSteps === 2,
              "completed-steps": _vm.activeSteps === 3,
              "notStarted-steps": _vm.activeSteps === 1,
            },
          },
          [_vm._v("2")]
        ),
        _c(
          "div",
          {
            staticStyle: { "margin-left": "5px" },
            style: {
              color:
                _vm.activeSteps === 2
                  ? "#0db35b"
                  : _vm.activeSteps === 1
                  ? "#a1a1a1"
                  : "#333",
            },
          },
          [_vm._v(_vm._s(_vm.$t("userManage.dataValidation")))]
        ),
      ]),
      _vm._m(1),
      _c("div", { staticClass: "steps-container" }, [
        _c(
          "div",
          {
            staticClass: "steps-index",
            class: {
              "active-steps": _vm.activeSteps === 3,
              "notStarted-steps":
                _vm.activeSteps === 1 || _vm.activeSteps === 2,
            },
          },
          [_vm._v("3")]
        ),
        _c(
          "div",
          {
            staticStyle: { "margin-left": "5px" },
            style: { color: _vm.activeSteps === 3 ? "#0db35b" : "#a1a1a1" },
          },
          [_vm._v(_vm._s(_vm.$t("userManage.CreationCompleted")))]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "steps-line" }, [
      _c("hr", { staticClass: "steps-line-hr" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "steps-line" }, [
      _c("hr", { staticClass: "steps-line-hr" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }